import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { spanishLocal } from './languages/spanish';
import { mexLocal } from './languages/mex';
import { portugueseLocal } from './languages/por';
import { EnglishLocal } from './languages/english';
import { italianLocal } from './languages/italian';
import { peruLocal } from './languages/peru';
import { ecuadorLocal } from './languages/ecuador';
import { chileLocal } from './languages/chile';
import { getDataUserByKey, getTenantInfoByKey } from './helpers/helpers';

const tenantLanguage = getTenantInfoByKey('language');

const userLanguage = getDataUserByKey('lang');

const stored_language = userLanguage || tenantLanguage || 'es';

const resources = {
  es: spanishLocal,
  mx: mexLocal,
  ch: chileLocal,
  br: portugueseLocal,
  en: EnglishLocal,
  it: italianLocal,
  pe: peruLocal,
  ec: ecuadorLocal
};

document.documentElement.setAttribute('lang', stored_language);

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: stored_language,
    fallbackLng: stored_language,
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', stored_language || lng);
});


export default i18n;
